module.exports = __webpack_public_path__ + "static/media/iconExamActive.b7399571.svg";